import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLHARAMICROSS', label: 'Harami Cross', lookback: 11 })
